import styled from "@emotion/styled";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  overflow: auto;
  min-height: 100vh;
  @supports (height: 100dvh) {
    min-height: 100dvh;
  }
  margin: auto;
  background-color: ${(p) => p.theme.colors.background2};
`;
